import React, { useEffect, useState } from 'react';
import AdminPanel from './components/adminPanel.js';
import Home from './components/Home.js';
import Login from './components/Login.js';
import Checkout from './components/Checkout.js';
import NavBar from './components/NavBar.js';
import NotFound from './components/NotFound.js';

function normalizePath(pathname = '/') {
  const normalized = pathname.replace(/\/+$/, '');
  return normalized || '/';
}

export default function App() {
  const [pathname, setPathname] = useState(() => (
    typeof window === 'undefined' ? '/' : window.location.pathname
  ));
  const normalizedPath = normalizePath(pathname);
  const isHomeRoute = normalizedPath === '/';
  const isAdminRoute = normalizedPath === '/admin';
  const isLoginRoute = normalizedPath === '/login';
  const isNotFoundRoute = !isHomeRoute && !isAdminRoute && !isLoginRoute;

  const [user, setUser] = useState(() => {
    if (typeof window === 'undefined') return null;
    const userJson = window.localStorage.getItem('rivemoderne_user') || window.sessionStorage.getItem('rivemoderne_user');
    if (!userJson) return null;
    try {
      return JSON.parse(userJson);
    } catch {
      return null;
    }
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const userJson = window.localStorage.getItem('rivemoderne_user') || window.sessionStorage.getItem('rivemoderne_user');
    if (!userJson) {
      setUser(null);
      return;
    }
    try {
      setUser(JSON.parse(userJson));
    } catch {
      setUser(null);
    }
  }, []);

  const handleLogout = () => {
    window.localStorage.removeItem('rivemoderne_token');
    window.localStorage.removeItem('rivemoderne_user');
    window.sessionStorage.removeItem('rivemoderne_token');
    window.sessionStorage.removeItem('rivemoderne_user');
    setUser(null);
    window.location.href = '/login';
  };

  useEffect(() => {
    if (isAdminRoute) {
      document.title = 'Rive Moderne | Admin';
      return;
    }

    if (isLoginRoute) {
      document.title = 'Rive Moderne | Login';
      return;
    }

    document.title = isNotFoundRoute ? 'Rive Moderne | 404' : 'Rive Moderne';
  }, [isAdminRoute, isLoginRoute, isNotFoundRoute]);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const syncPath = () => {
      setPathname(window.location.pathname);
    };

    window.addEventListener('popstate', syncPath);
    return () => window.removeEventListener('popstate', syncPath);
  }, []);

  if (isAdminRoute) {
    if (!user || user.user_type !== 'admin') {
      window.location.href = '/login';
      return null;
    }
    return (
      <div className="app-shell">
        <main className="admin-shell">
          <AdminPanel user={user} setUser={setUser} />
        </main>
      </div>
    );
  }

  const isCheckoutRoute = normalizedPath === '/checkout';

  if (isLoginRoute) {
    if (user) {
      if (user.user_type === 'admin') {
        window.location.href = '/admin';
        return null;
      }
      window.location.href = '/';
      return null;
    }
    return (
      <div className="app-shell">
        <main className="auth-shell"><Login onLogin={setUser} /></main>
      </div>
    );
  }

  if (isCheckoutRoute) {
    return (
      <div className="app-shell">
        <main className="checkout-shell"><Checkout /></main>
      </div>
    );
  }


  return (
    <div className="app-shell">
      <NavBar />
      <main className={isNotFoundRoute ? 'not-found-shell' : 'home-shell'}>
        {isNotFoundRoute ? <NotFound /> : <Home />}
      </main>
    </div>
  );
}
